import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompensator = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 80,
	viewBox: "0 0 40.0 80.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 20.0 0.0 A 50.0 50.0 0.0 0 1 20.0 80.0 A 50.0 50.0 0.0 0 1 20.0 0.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgCompensator;
